<script lang="ts">
    import { onDestroy } from 'svelte';
    import Regex from '../../lib/regex';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '#000000';
    export let disabled: boolean = false;

    errors[name] = [];

    const validate = (val: string = value) => {
        errors[name] = [];
        if (!Regex.HexColor.test(val)) {
            errors[name].push('Invalid color value');
        }
    };
    validate();

    const handleInput = (e: Event) => validate((e.currentTarget as HTMLInputElement).value);

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <div class="color-row">
        <input
            type="color"
            {name}
            {disabled}
            bind:value
            on:input={handleInput}
            class:error={errors[name].length > 0}
            on:change
        />
        <span class="color-value">{value}</span>
    </div>
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
